import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAdminAuth } from '../utils/AdminAuthContext';

export default function ProtectedAdminRoute({ children }) {
  const { isAdminLoggedIn } = useAdminAuth();
  if (!isAdminLoggedIn) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
}